import cx from 'classnames';
import SkeletonLoader from 'components/skeleton-loader';
import { TalkCardSizes } from 'components/talk-card';

type TalkCardSkeletonProp = {
  size?: TalkCardSizes;
  className?: string;
};

const TalkCardSkeleton = ({
  size = 's',
  className = ''
}: TalkCardSkeletonProp) => {
  const isLargeCard = size === 'l';
  const isMediumCard = size === 'm';
  const isSmallCard = size === 's';

  const titleClassName = cx({
    'mt-5 xl:mt-6': isLargeCard,
    'mt-4 md:mt-5 xl:mt-6': isMediumCard,
    'mt-4 xl:mt-5': isSmallCard
  });

  const contentClassName = cx({
    'mt-6 md:mt-4 xl:hidden': isLargeCard,
    'hidden md:mt-5 md:block': isMediumCard,
    'mt-5 md:mt-4 xl:mt-5': isSmallCard
  });

  const numberOfTitleLines = isSmallCard ? 3 : 2;
  const numberOfContentLines = 5;

  return (
    <div className={`group block ${className}`}>
      <SkeletonLoader.Image ratio={[16, 9]} />
      <SkeletonLoader.Title
        className={titleClassName}
        numberOfLines={numberOfTitleLines}
      />
      <SkeletonLoader.Content
        className={contentClassName}
        numberOfLines={numberOfContentLines}
      />
    </div>
  );
};

export default TalkCardSkeleton;
